import { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import { useSelector } from 'react-redux'

import { modalSelector } from '../../store/modalSlice'

import AlertModal from './AlertModal'
import AiMentoringModal from './AiMentoringModal'
import ConfirmModal from './ConfirmModal'
import UpdateDailyLogModal from './daily_logs/UpdateDailyLogModal'
import GetDailyLogModal from './daily_logs/GetDailyLogModal'
import UpdateSessionalPlanModal from './plans/UpdateSessionalPlanModal'
import UpdateSubjectModal from './plans/UpdateSubjectModal'
import UpdateWeeklyDelayModal from './plans/UpdateWeeklyDelayModal'
import UpdateDailyDelayModal from './plans/UpdateDailyDelay'
import UpdateQuantityModal from './plans/UpdateQuantityModal'
import SelectReportTypeModal from './SelectReportTypeModal'
import LeaveModal from './profile/LeaveModal'
import ModifyPwModal from './profile/ModifyPwModal'

const MODAL_COMPONENTS = {
  alert: AlertModal,
  aiMentoring: AiMentoringModal,
  confirm: ConfirmModal,
  updateDailyLog: UpdateDailyLogModal,
  getDailyLog: GetDailyLogModal,
  updateSessionalPlan: UpdateSessionalPlanModal,
  updateSubject: UpdateSubjectModal,
  updateWeeklyDelay: UpdateWeeklyDelayModal,
  updateDailyDelay: UpdateDailyDelayModal,
  updateQuantity: UpdateQuantityModal,
  selectReportType: SelectReportTypeModal,
  leave: LeaveModal,
  modifyPw: ModifyPwModal,
}

function ModalContainer() {
  const modalList = useSelector(modalSelector)
  const prevLength = useRef(modalList.length)

  useEffect(() => {
    if (modalList.length > prevLength.current) {
      window.history.pushState({ modalOpened: true }, '')
    }
    prevLength.current = modalList.length
  }, [modalList.length])

  const renderModal = modalList.map(({ type, props }) => {
    const ModalComponent = MODAL_COMPONENTS[type]
    return <ModalComponent key={type} { ...props } />
  })
  return createPortal(
    <>{renderModal}</>
    , document.getElementById("modal")
  )
}

export default ModalContainer